import { useQuery } from "@apollo/client/react";
import { gql } from "@apollo/client";
import { image } from "querypieces";

const query = gql`
  {
    entries(section: "blog", limit: 3) {
      ... on blog_Entry {
        id
        uri
        title
        ${image}
      }
    }
  }
`;

const useMoreBlog = (props = {}) => {
  const { excludeIds = [] } = props;
  return useQuery(query, {
    variables: {
      id: excludeIds.map((d) => `not ${d}`),
    },
  });
};

export default useMoreBlog;
